export const downtime = [
	'24 24',
	`
<path opacity="0.5" d="M10.606 3.73047H9.35596V10.6879L13.8721 12.8343L14.4087 11.7054L10.606 9.89801V3.73047Z"/>
<path opacity="0.5" d="M10 0.625C4.82234 0.625 0.625 4.82234 0.625 10C0.625 15.1777 4.82234 19.375 10 19.375C15.1777 19.375 19.375 15.1777 19.375 10C19.375 4.82234 15.1777 0.625 10 0.625ZM10 18.125C5.5127 18.125 1.875 14.4873 1.875 10C1.875 5.5127 5.5127 1.875 10 1.875C14.4873 1.875 18.125 5.5127 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125Z"/>
`,
];
